var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lost-view"}},[_c('h1',[_vm._v("Page Not Found")]),_c('h4',[_vm._v("One of us is lost.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Take me home.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }